export const RequestConfig = (config = {}) => {
  let token = window.localStorage.getItem("token");
  token = "Bearer " + token;
  let responseHeader = {
    headers: {
      Authorization: token,
      ...config.headers,
    },
    timeout: 0,
    ...config,
  };
  return responseHeader;
};
